<script>
    /**
     * zeluslugi.ru
     * @author      delphinpro <delphinpro@gmail.com>
     * @copyright   copyright © 2018 delphinpro
     * @license     licensed under the MIT license
     */

    export default {
        name: "calc-static-info",

        props:{
            items: Array
        },

        data: () => ({}),

    };
</script>

<template>
  <div class="calc__static-info">
    <div class="calc__group calc__group_static"
         v-for="item in items"
    >
      <div class="calc__label">
        <span class="calc__form-label form-label">{{item.title}}:</span>
      </div>
      <div class="calc__static">{{item.desc}}</div>
    </div><!-- // .calc__group -->
  </div>
</template>
